export const ImageType = {
  MESSAGE_TEMPLATE: 'MESSAGE_TEMPLATE',
  WORKFLOW_ICON: 'WORKFLOW_ICON',
  FLOW_ICON: 'FLOW_ICON',
};

export const ImageTypeValues = [
  ImageType.MESSAGE_TEMPLATE,
  ImageType.WORKFLOW_ICON,
  ImageType.FLOW_ICON,
];

export const FLOW_ICON_SUGGESTED_SIZE_PX = 36;
export const WORKFLOW_ICON_SUGGESTED_SIZE_PX = 120;

export const CUSTOM_CHANNEL_ICON =
  '/static/images/logos/generic-collaboration-channel.svg';
export const DEFAULT_WORKFLOW_ICON = '/static/images/logos/CUSTOM_WORKFLOW.png';
export const DEFAULT_XM_LOGO_PATH = '/static/images/svg/logo.svg';
export const EVERBRIDGE_LOGO_PATH = '/static/images/logos/EVERBRIDGE.svg';
export const EVERBRIDGE_LONG_LOGO_PATH = '/static/images/logos/EVERBRIDGE_LONG_LOGO.svg';
export const INITIATE_INCIDENT_ICON = '/static/images/icons/incident.svg';
export const MICROSOFT_TEAM_LOGO_PATH = '/static/images/logos/MS_TEAMS.svg';
export const SLACK_LOGO_PATH = '/static/images/logos/SLACK.svg';
export const XM_CONFERENCE_PATH =
  '/static/images/icons/x-matters-conference.svg';
export const ZOOM_LOGO_PATH = '/static/images/logos/ZOOM.svg';
